import { ActivatedRouteSnapshot } from '@angular/router';

import { ClientConfigProductName } from '@frontend/vanilla/core';

import { SamePathAppVersion } from '../app.version.enum';
import { allowedProductGuard, isSportsVersionMatch, matchAppVersionProductLoadGuard, productUnderMaintenanceGuard } from '../guards';
import { RoutesConfig } from './routes-config';

const routes: RoutesConfig = {
    routes: [
        {
            path: 'sports',
            loadChildren: () => import('@frontend/oxygen/ld-host-app').then((t) => t.LDHostAppModule),
            canMatch: [
                allowedProductGuard,
                (route: ActivatedRouteSnapshot) =>
                    matchAppVersionProductLoadGuard(ClientConfigProductName.SPORTS, SamePathAppVersion.LADBROKES_DESKTOP_APP, route),
            ],
            canActivate: [
                (route: ActivatedRouteSnapshot) =>
                    productUnderMaintenanceGuard(route, ClientConfigProductName.SPORTS, SamePathAppVersion.LADBROKES_DESKTOP_APP),
            ],
            data: {
                product: ClientConfigProductName.OZONE,
                canPreload: [isSportsVersionMatch(SamePathAppVersion.LADBROKES_DESKTOP_APP), allowedProductGuard],
            },
        },
    ],
};

export default routes;
